// extracted by mini-css-extract-plugin
module.exports = {"logo":"Admin_logo__EDB25","toolbar":"Admin_toolbar__2glHD","nested":"Admin_nested__5FSvw"};